module.exports = __webpack_public_path__ + "static/media/MAI-av3CRV.d0510f02.svg";